// import components
import {
  alpha,
  keyframes,
  styled,
  Typography,
  TypographyProps
} from '@mui/material';

export const StyledTypographyTruncate = styled(Typography)<TypographyProps>(
  () => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 200
  })
);

export const StyledTypographyLineClamped = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'lineClamp'
})<TypographyProps & { lineClamp?: number }>(({ lineClamp = 1 }) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: lineClamp
}));

export const StyledTypographyBodyBold = styled(Typography)<TypographyProps>(
  () => ({
    fontFamily: 'SourceSansPro-Semibold'
  })
);

export const StyledTypographyHtmlFontSize = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    fontSize: theme.typography.htmlFontSize,
    lineHeight: 'normal'
  })
);

export const StyledTypographyBoldHtmlFontSize = styled(
  Typography
)<TypographyProps>(({ theme }) => ({
  fontFamily: 'SourceSansPro-Semibold',
  fontSize: theme.typography.htmlFontSize
}));

export const StyledTypographyNormalLineHeight = styled(
  Typography
)<TypographyProps>(() => ({
  lineHeight: 'normal',
  textWrap: 'balance'
}));

export const StyledTypographyNormalLineHeightBold = styled(
  Typography
)<TypographyProps>(() => ({
  lineHeight: 'normal',
  fontFamily: 'SourceSansPro-Bold',
  textWrap: 'balance'
}));

export const StyledTypographyNormalLineHeightSemiBold = styled(
  Typography
)<TypographyProps>(() => ({
  lineHeight: 'normal',
  fontFamily: 'SourceSansPro-SemiBold',
  textWrap: 'balance'
}));

const shimmer = keyframes`
  0%   { background-position: -125px 0; }
  100% { background-position: calc(100% + 125px) 0; }
`;

export const StyledShimmeredTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'bgColor'
})<TypographyProps & { bgColor?: string }>(({ theme, bgColor = '#fff' }) => ({
  display: 'inline-block',
  textAlign: 'center',
  color: alpha(theme.palette.common.white, 0.1),
  backgroundImage: `linear-gradient(90deg, ${theme.palette.text.primary} 0%, ${bgColor} 50%, ${theme.palette.text.primary} 100%)`,
  backgroundSize: '125px 100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '0 0',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animation: `${shimmer} 4s linear infinite`,
  backgroundColor: '#222'
}));

export const StyledShimmeredTypographyBold = styled(
  StyledShimmeredTypography
)<TypographyProps>(() => ({
  textAlign: 'left',
  minHeight: 20,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,

  '&&': {
    fontFamily: 'SourceSansPro-Semibold'
  }
}));

export const StyledTypographyDisplayBlock = styled(Typography)<TypographyProps>(
  () => ({
    display: 'block'
  })
);

export const StyledTypographyFlexGrow = styled(Typography)<TypographyProps>(
  () => ({
    display: 'block',
    flexGrow: 1
  })
);

export const StyledTypographyEllipsisNormal = styled(
  Typography
)<TypographyProps>(() => ({
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: 'normal'
}));
